import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class UploadAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'File';

  public uploadFile(formData: FormData) {
    const request = 'uploadFiles';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.upload<app.models.ServerResponseModel>(url, formData);
  }

  public getFileById(fileId: string) {
    const request = `getFileById/${fileId}`;
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.getRaw(url, null);
  }

  public extractIdentificationInfo(formData: FormData) {
    const request = 'extractIdentificationInfo';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.postGet<app.models.GetPersonInfo>(url, formData);
  }
}
